/* post-t7-1, Bloque C (#594 y #598): LOS TEXTOS QUE EL MOTOR DE ESTUDIO MANDA YA REDACTADOS, EN EL IDIOMA DE LA PERSONA.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   El motor (`services/engine_core.py` y su gemelo de la app, intocables) manda dos cosas en ingles que la pagina
   pintaba tal cual: la recomendacion del final de una sesion de Estudio Adaptativo y la palabra "Deleted" en los
   nombres de una sesion cuyo documento se borro. Aqui se reconocen esas cadenas EXACTAS y se pintan con su par del
   idioma; una cadena que no se reconoce pasa tal cual (lo de antes). Sirve igual en la web y en la app (aun sin red):
   no toca al motor, solo a lo que la pagina pinta. */

const DEBIL = 'Focus your next study sessions on your weak areas. The adaptive algorithm will prioritize these topics '
  + 'automatically, but targeted review of the underlying concepts will accelerate your mastery.';
const FUERTE = 'Great performance! Continue with adaptive sessions to maintain retention and push into higher '
  + "Bloom's taxonomy levels.";

/** Las dos recomendaciones del motor, letra por letra (`engine_core.RECOMMENDATION_WEAK_AREAS` y
    `RECOMMENDATION_ALL_STRONG`); una prueba las compara con el archivo del motor. */
export const RECOMENDACIONES_DEL_MOTOR = {
  [DEBIL]: 'study:adaptive.summary.recommendation_weak_areas',
  [FUERTE]: 'study:adaptive.summary.recommendation_all_strong',
};

/** La recomendacion del motor en el idioma de la persona; una que no se reconoce, tal cual. */
export function recomendacionDelMotor(t, texto) {
  const llave = typeof texto === 'string' ? RECOMENDACIONES_DEL_MOTOR[texto.trim()] : null;
  return llave ? t(llave) : texto;
}

/** post-t7-1 (C3, #598): la palabra con que el servidor (y su gemelo de la app) nombra un documento que ya se borro. */
export const NOMBRE_DE_LO_BORRADO = 'Deleted';
/** El separador con que el servidor une los nombres de las cards de una sesion en UN solo elemento
    (`routes/study.py::_SEPARADOR_DE_CARDS`). */
export const SEPARADOR_DE_CARDS = ', ';

/** Los nombres de una sesion con "Deleted" en el idioma de la persona, venga solo o como una pieza del elemento que
    junta las cards. Un documento que de verdad se llame "Deleted" se acepta como caso raro. */
export function nombresDeLaSesion(t, nombres) {
  if (!Array.isArray(nombres)) return nombres;
  const borrado = t('study:log.deleted');
  return nombres.map((n) => (typeof n !== 'string' ? n
    : n.split(SEPARADOR_DE_CARDS).map((pieza) => (pieza === NOMBRE_DE_LO_BORRADO ? borrado : pieza)).join(SEPARADOR_DE_CARDS)));
}
